/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=e4fab7c0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e4fab7c0&lang=css"

import exportComponent from "D:\\xiao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__